// utils pour forcer passive: true sur certains events (touchstart, touchmove, wheel)
// use : import { applyPassiveEventsPatch } from './utils/passiveEventsPatch'; applyPassiveEventsPatch();

export function applyPassiveEventsPatch(): void {
  if (typeof window === 'undefined' || typeof EventTarget === 'undefined')
    return
  const origAddEventListener = EventTarget.prototype.addEventListener
  const passiveEvents = ['touchstart', 'touchmove', 'wheel']

  EventTarget.prototype.addEventListener = function (
    this: EventTarget,
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions,
  ): void {
    if (
      passiveEvents.includes(type) &&
      (options === undefined ||
        (typeof options === 'object' &&
          (options as AddEventListenerOptions).passive === undefined))
    ) {
      if (typeof options === 'object') {
        options = { ...options, passive: true }
      } else {
        options = { passive: true }
      }
    }
    // @ts-ignore
    return origAddEventListener.call(this, type, listener, options)
  }
}
